import { WindowService } from './../../services/window-dialogs/window.service';
import { Component, OnInit } from '@angular/core';
import { DialogService } from '../../../app/services/modal-dialogs';
import { GlobalService } from '../../services/global.service';
import { ssApiService } from '../../services/ss-api.service';
import { LicenseManager } from '../../managers/License.manager';
import { SortBot } from '../../helpers/sort';
import { PoolStudioBubbleDialog } from 'app/dialogs/poolstudio.bubble/poolstudio.bubble.dialog';
import { BubbleItemArray } from '@models/domain/bubble.item';
import { GetBubblesRequest } from '@models/ss-api/requests/get.bubbles.request';

@Component({
    selector: 'bubbles',
    templateUrl: './bubble.editor.component.html',
    styleUrls: ['./bubble.editor.component.scss']
})

export class BubbleEditorComponent implements OnInit {
    IsBusy: boolean = false;

    Bubbles: BubbleItemArray;
    BubblesFilter: string;

    ActiveOnly: boolean = true;

    resultRows: number = 25;
    firstResult: number = 0;
    lastResult: number = 24;

    constructor(private dialogService: DialogService, private gb: GlobalService, private api: ssApiService, private windowService: WindowService) { }

    ngOnInit() {
        this.gb.SetPageTitle('Bubble Editor');
        // this.IsBusy = true;
        this.LoadBubbles();
    }

    paginateBenchmarks(e) {
        // console.log("paginateSearch :", e);
        this.firstResult = e.page * e.rows;
        this.lastResult = this.firstResult + e.rows;
    }
 

    LoadBubbles() {
        this.IsBusy = true;

        var request = new GetBubblesRequest();
        request.ActiveOnly = this.ActiveOnly;

        let disposable = this.api.GetBubbles(request).subscribe(response => {
            this.IsBusy = false;

            var bubbles = response.Data;
            bubbles.forEach((bub) => {
                switch(bub.BubbleGroupName){
                    case "Info":
                        bub.BubbleGroupName = "Info (Green)";
                        break;
                    case "Warning":
                        bub.BubbleGroupName = "Warning (Yellow)";
                        break;
                    case "Error":
                        bub.BubbleGroupName = "Error (Red)";
                        break;
                    case "Promotion":
                        bub.BubbleGroupName = "Promotion (Blue)";
                        break;
                }
            });                
            
            this.Bubbles = bubbles;
            console.log("cbm", this.Bubbles);
            disposable.unsubscribe();
        });
    }

    AddBubble() {
        let disposable = this.dialogService.addDialog(PoolStudioBubbleDialog, {
            Title: 'Add Bubble'
        }, { width: 600, height: 1000 }).subscribe(response => {
            disposable.unsubscribe();
            if (response) {
                this.LoadBubbles();
            }
        });
    }

    EditBubble(bubbleItem) {
        let disposable = this.dialogService.addDialog(PoolStudioBubbleDialog, {
            Title: 'Edit Bubble',
            Bubble: bubbleItem
        }, { width: 600, height: 1000 }).subscribe(response => {
            disposable.unsubscribe();
            this.LoadBubbles();
        });
    }

   
    ToggleActiveOnly() {
        this.ActiveOnly = !this.ActiveOnly;
        this.LoadBubbles();
    } 

    SortBy( sortVar1: string, sortVar2: string = '' ) {
        this.Bubbles = SortBot.SortAuto( this.Bubbles, sortVar1, sortVar2);
    }

    onSearchTable(term) {
        this.BubblesFilter = term;
    }

}
